module.exports = __webpack_public_path__ + "media/images/emblems/Bofflens-coat_of_arms-132f370a9765c45614a7a3f95f273404.svg";